module.exports = __webpack_public_path__ + "static/img_4239-ea42310b0d03ccdc3462425fb41f21b7.jpg";